import Script from 'next/script';

export const OneSignalScript: React.FC = () => {
  return (
    <Script
      defer={true}
      id="oneSignalScript"
      key="oneSignalScript"
      src="https://cdn.onesignal.com/sdks/OneSignalSDK.js"
      strategy="lazyOnload"
      type="text/javascript"
    />
  );
};

export default OneSignalScript;
